export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) => state.all.find((administrator) => administrator.id == Vue.$route.params.id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, administrators) {
      state.all = administrators.map(a => ({ ...a, $type: 'Administrator' }))
      state.loading = false
    },
    set(state, administrator) {
      state.all = state.all.filter((o) => o.id != administrator.id)
      state.all.push({ ...administrator, $type: 'Administrator' })
    },
    remove(state, id) {
      state.all = state.all.filter((o) => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      this.$authorize('list', 'Administrator')

      commit('startLoading')
      return Vue.$http
        .get('admin/administrators')
        .then((response) => commit('setAll', response.data), (response) => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Administrator')

      return Vue.$http.get(`admin/administrators/${id}`).then((response) => commit('set', response.data))
    },
    create({ commit }, administrator) {
      this.$authorize('create', 'Administrator')

      return Vue.$http.post('admin/administrators', { administrator }).then(
        (response) => {
          commit('set', response.data)
          return response.data
        },
        (response) => Object.assign(administrator, response.data)
      )
    },
    update({ commit }, administrator) {
      this.$authorize('edit', administrator)

      return Vue.$http.patch(`admin/administrators/${administrator.id}`, { administrator }).then(
        (response) => {
          commit('set', response.data)
        },
        (response) => commit('set', Object.assign(administrator, response.data))
      )
    },
    role({ commit }, administrator) {
      this.$authorize('create', administrator)

      return Vue.$http.patch(`admin/administrators/${administrator.id}/role`, { administrator }).then(
        (response) => {
          commit('set', response.data)
        },
        (response) => commit('set', Object.assign(administrator, response.data))
      )
    },
    destroy({ commit }, id) {
      this.$authorize('delete', { id, $type: 'Administrator' })

      return Vue.$http.delete(`admin/administrators/${id}`).then((response) => commit('remove', id))
    }
  }
}
